import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
// Import Shared Components
import { Modal, ActionBar, ButtonGroup, Loader } from 'shared-components';
// Import Global Components
import Heading from '../../../components/Heading';
import Text from '../../../components/Text';
import Button from '../../../components/Button';
import CancelButton from '../../../components/CancelButton';
import Alert from '../../../components/Alert';
// Import Global Layouts
import { ModalFormContainer } from '../../../layouts/Form';

const ConfirmSuspendModal = ({ status, loading, error, onConfirm, onCancel }) => {
  const intl = useIntl();

  return (
    <Modal>
      <ModalFormContainer>
        {error && (
          <Alert
            alert={intl.messages[`${status}-card-error-alert`]}
            alertFor={`${status}-card-error`}
            type="danger"
          />
        )}
        <Heading
          page={`home-confirm-${status}`}
          heading={intl.messages[`home-confirm-${status}-heading`]}
        />
        {loading ? (
          <Loader />
        ) : (
          <>
            <Text
              text={intl.messages[`home-confirm-${status}-text`]}
              textFor={`confirm-${status}`}
              page="home"
            />
            <ActionBar>
              <ButtonGroup reverse>
                <Button
                  page="home"
                  buttonFor={`confirm-${status}`}
                  type="primary"
                  size="large"
                  buttonText={intl.messages[`home-confirm-${status}-button`]}
                  onClick={onConfirm}
                />
                <CancelButton onClick={onCancel} type="neutral" />
              </ButtonGroup>
            </ActionBar>
          </>
        )}
      </ModalFormContainer>
    </Modal>
  );
};

ConfirmSuspendModal.propTypes = {
  status: PropTypes.oneOf(['suspend', 'unsuspend']).isRequired,
  loading: PropTypes.bool,
  error: PropTypes.bool,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

ConfirmSuspendModal.defaultProps = {
  loading: false,
  error: false,
};

export default ConfirmSuspendModal;
